var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from '@max/max';
import { LIST_STATUS, LOAD_MORE_STATUS } from '../components/list-container/types';
import { useRequest } from './useRequest';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
const INIT_PAGE_NUM = 1;
export var RequestType;
(function (RequestType) {
    RequestType["INIT"] = "init";
    RequestType["LOAD_MORE"] = "loadMore";
})(RequestType || (RequestType = {}));
export function useRequestList(mapper, pageSize, feConfig) {
    const { response, request, isLoading, isSuccess, isError } = useRequest();
    const requestTypeRef = useRef(RequestType.INIT);
    const ctx = useMonitorEngineContext();
    const pageSizeRef = useRef(pageSize);
    const pageNoRef = useRef(INIT_PAGE_NUM);
    const feMoreListRef = useRef([]);
    useEffect(() => {
        if (isSuccess) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.SUCCESS) : setLoadMoreStatus(LOAD_MORE_STATUS.SUCCESS);
        }
        if (isError) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.ERROR) : setLoadMoreStatus(LOAD_MORE_STATUS.ERROR);
        }
        if (isLoading) {
            requestTypeRef.current === RequestType.INIT ? setListStatus(LIST_STATUS.LOADING) : setLoadMoreStatus(LOAD_MORE_STATUS.LOADING);
        }
    }, [isSuccess, isError, isLoading, response]);
    const [listStatus, setListStatus] = useState(LIST_STATUS.SUCCESS);
    const [loadMoreStatus, setLoadMoreStatus] = useState(LOAD_MORE_STATUS.SUCCESS);
    const [isLastPage, setIsLastPage] = useState(false);
    const [feListVo, setListFeVo] = useState([]);
    const requestList = (options, requestType) => __awaiter(this, void 0, void 0, function* () {
        requestTypeRef.current = requestType;
        const { onSuccess } = options;
        if (requestType === RequestType.INIT) {
            pageNoRef.current = 1;
            setIsLastPage(false);
        }
        options.requestConfig.params.pageSize = requestType === RequestType.INIT ? pageSizeRef.current * 2 : pageSizeRef.current;
        options.requestConfig.params.pageNo = pageNoRef.current;
        const onSuccessProxy = (res) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            if (((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                (_d = (_c = ctx._raptorReport).monitorReportBizSuccess) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: (_e = options === null || options === void 0 ? void 0 : options.requestConfig) === null || _e === void 0 ? void 0 : _e.path
                });
                (_g = (_f = ctx._raptorReport).monitorReportShelfNormal) === null || _g === void 0 ? void 0 : _g.call(_f, {
                    apiPath: (_h = options === null || options === void 0 ? void 0 : options.requestConfig) === null || _h === void 0 ? void 0 : _h.path
                });
                const newFeList = mapper(res, feConfig);
                if (requestTypeRef.current === RequestType.INIT) {
                    const shoList = newFeList.slice(0, pageSizeRef.current);
                    const feMoreList = newFeList.slice(pageSizeRef.current);
                    feMoreListRef.current = feMoreList;
                    setListFeVo(shoList);
                }
                else {
                    if (feListVo) {
                        setListFeVo([...feListVo, ...newFeList]);
                    }
                }
                if (requestType === RequestType.INIT) {
                    pageNoRef.current = 3;
                }
                else {
                    pageNoRef.current += 1;
                    if (pageNoRef.current > res.data.totalPage) {
                        setIsLastPage(true);
                    }
                }
            }
            else {
                setIsLastPage(true);
                (_k = (_j = ctx._raptorReport).monitorReportBizFailed) === null || _k === void 0 ? void 0 : _k.call(_j, {
                    apiPath: (_l = options === null || options === void 0 ? void 0 : options.requestConfig) === null || _l === void 0 ? void 0 : _l.path
                });
                if (((_o = (_m = res === null || res === void 0 ? void 0 : res.data) === null || _m === void 0 ? void 0 : _m.list) === null || _o === void 0 ? void 0 : _o.length) === 0) {
                    (_q = (_p = ctx._raptorReport).monitorReportShelfEmpty) === null || _q === void 0 ? void 0 : _q.call(_p, {
                        city_id: (_t = (_s = (_r = options === null || options === void 0 ? void 0 : options.requestConfig) === null || _r === void 0 ? void 0 : _r.params) === null || _s === void 0 ? void 0 : _s.cityId) === null || _t === void 0 ? void 0 : _t.toString(),
                        apiPath: (_u = options === null || options === void 0 ? void 0 : options.requestConfig) === null || _u === void 0 ? void 0 : _u.path
                    });
                }
            }
            if (onSuccess) {
                onSuccess(res);
            }
        };
        options.onSuccess = onSuccessProxy;
        if (requestType === RequestType.LOAD_MORE && feMoreListRef.current.length > 0) {
            setListFeVo([...feListVo, ...feMoreListRef.current]);
            feMoreListRef.current = [];
        }
        else {
            request(options);
        }
    });
    return {
        response,
        feListVo,
        listStatus,
        loadMoreStatus,
        isLastPage,
        requestList
    };
}
